var map = {
	"./check.png": 163,
	"./frame.png": 290,
	"./frame_mobile.png": 291,
	"./guide.png": 164,
	"./index_finger_left.png": 292,
	"./index_finger_right.png": 293,
	"./middle_finger_left.png": 294,
	"./middle_finger_right.png": 295,
	"./pinky_finger_left.png": 296,
	"./pinky_finger_right.png": 297,
	"./result.png": 114,
	"./ring_finger_left.png": 298,
	"./ring_finger_right.png": 299,
	"./thumb_finger_left.png": 300,
	"./thumb_finger_right.png": 301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;